






































































































































































































































































































































































































































import cInput from "@/components/FormElements/CustomInput.vue";
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import DatePicker from "vuejs-datepicker";
import ebSelect from "@/components/FormElements/Select.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";

@Component({
  components: {
    cInput,
    ebSelect,
    DatePicker,
    ValidationObserver,
    ValidationProvider,
  },
})
export default class Agreement extends Vue {
  public selectAllCatalog = false;
  public selectAllMarket = false;

  get marketOptions() {
    return [
      {
        label: "Market",
        value: "MARKET",
      },
      //   {
      //     label: "Category",
      //     value: "CATEGORY"
      //   }
      // {
      //   label: "Domain",
      //   value: "DOMAIN"
      // },
      // {
      //   label: "Product Type",
      //   value: "PRODUCT_TYPE"
      // },
    ];
  }
  get getwayoption() {
    return [
      {
        label: "COD",
        value: "COD",
      },
      {
        label: "Cash Free",
        value: "CASHFREE",
      },
      {
        label: "Paytm",
        value: "PAYTM",
      },
    ];
  }

  get salesOption() {
    return [
      {
        text: "Online",
        value: "ONLINE",
      },
      {
        text: "Offline",
        value: "OFFLINE",
      },
      {
        text: "Hybrid",
        value: "HYBRID",
      },
    ];
  }

  @Prop()
  showPaymentPicker:any;
  @Prop()
  showsellerPaymentPicker: any;
  @Prop()
  catalogDomainData: any;

  get catalogsOptionsMarket() {
    try {
      if (
        Array.isArray(this.marketListStore) &&
        this.marketListStore.length > 0 &&
        this.marketListStore[0].isMarket
      ) {
        return this.marketListStore;
      } else {
        return [];
      }
    } catch {
      return [];
    }
  }
  get catalogsOptionsAll() {
    let catalogs = this.$store.getters["catalog/GetCatalogTree"];

    let filtercatalogs = [];

    if (this.agreement.market === null) {
      return [];
    } else if (this.agreement.market.value === "DOMAIN") {
      filtercatalogs = catalogs.filter((obj) => obj.isDomain);
      return filtercatalogs;
    } else if (this.agreement.market.value === "MARKET") {
      filtercatalogs = catalogs.filter((obj) => obj.isMarket);
      return filtercatalogs;
    } else if (this.agreement.market.value === "PRODUCT_TYPE") {
      filtercatalogs = catalogs.filter((obj) => obj.isProductType);
      return filtercatalogs;
    } else if (this.agreement.market.value === "CATEGORY") {
      filtercatalogs = catalogs.filter((obj) => obj.isCategory);
      return filtercatalogs;
    }
  }
  @Watch("agreement.keys")
  onChange(newVal, oldVal) {
    this.agreement.paymentOptionKeys = [];
    newVal.forEach((element) => {
      this.agreement.paymentOptionKeys.push(element.value);
    });
  }
  public selectAllMarketCategory() {
    this.agreement.catalog = [];
    if (this.selectAllMarket) {
      this.catalogsOptionsMarket.map((x) => {
        this.agreement.catalog.push(x);
      });
    }
    this.fetchAllSelectedMarketCatagory();
  }
  public selectAllCatalogCategory() {
    this.agreement.catalogCategory = [];
    if (this.selectAllCatalog) {
      this.catalogsOptionsCategory.map((x) => {
        this.agreement.catalogCategory.push(x);
      });
    }
  }
  public async fetchAllSelectedMarketCatagory() {
    this.agreement.catalogCategory = [];
    this.catalogsOptionsCategory = [];

    let data = this.agreement.catalog;

    try {
      if (Array.isArray(data) && data.length > 0) {
        let searchString = "";
        this.isLoadingCat = true;
        data.forEach(async (el) => {
          searchString = `parent=${el._id}`;
          await this.$store.dispatch("catalog/fetchCatalogList", searchString);
          this.catalogsOptionsCategory.push(
            ...this.$store.getters["catalog/GetCategoryList"].data.response
          );
        });

        this.isLoadingCat = false;
      }
    } catch {
      this.catalogsOptionsCategory = [];
    }

    if (Array.isArray(data) && data.length == 0) {
      this.catalogsOptionsCategory = [];
    }
  }

  @Watch("agreement.parentOrg")
  onChange1(newVal, oldVal) {
    if (newVal) {
      if (this.$store.getters["partner/GetPartnerPaymentConfig"] != null) {
        let parentPaymentData =
          this.$store.getters["partner/GetPartnerPaymentConfig"];
        this.agreement.keys = [];
        if (parentPaymentData.cashfree) {
          this.agreement.secretkeyCashFree =
            parentPaymentData.cashfree.secretKey;
          this.agreement.appkeyCashFree = parentPaymentData.cashfree.appId;
          this.agreement.keys.push({
            label: "Cash Free",
            value: "CASHFREE",
          });
        }
        if (parentPaymentData.paytm) {
          this.agreement.secretkeyPaytm = parentPaymentData.paytm.secretKey;
          this.agreement.appkeyPaytm = parentPaymentData.paytm.appId;
          this.agreement.keys.push({
            label: "Paytm",
            value: "PAYTM",
          });
        }

        if (sessionStorage.getItem("userRole") == "Tenant") {
          if (
            this.$store.getters["tenant/GetTenantPreferences"].paymentMethod
          ) {
            if (
              this.$store.getters["tenant/GetTenantPreferences"].paymentMethod
                .cod
            ) {
              this.agreement.keys.push({
                label: "COD",
                value: "COD",
              });
            }
          }
        }
        if (sessionStorage.getItem("userRole") == "Partner") {
          if (
            this.$store.getters["partner/getPartnerPaymentPreferencesGetter"]
              .preferences.paymentMethod
          ) {
            if (
              this.$store.getters["partner/getPartnerPaymentPreferencesGetter"]
                .preferences.paymentMethod.cod
            ) {
              this.agreement.keys.push({
                label: "COD",
                value: "COD",
              });
            }
          }
        }
      } else {
      }
    } else {
      this.agreement.keys = [];
      this.agreement.secretkeyCashFree = "";
      this.agreement.appkeyCashFree = "";
      this.agreement.secretkeyPaytm = "";
      this.agreement.appkeyPaytm = "";
    }
  }

  public vendorModeOptions: any = [
    {
      label: "Paytm",
      value: "PAYTM",
    },
    {
      label: "Cashfree",
      value: "CASHFREE",
    },
  ];
  public catalogsOptionsCategory: any = [];
  public loading: Boolean = false;
  public isLoading: Boolean = false;
  public isLoadingCat: Boolean = false;
  public marketListStore: any = [];
  public isMarketShow: Boolean = true;
  public agreement: any = {
    market: null,
    catalog: null,
    catalogCategory: null,
    parentOrg: false,
    file: "",
    keys: [],
    paymentOptionKeys: [],
    appkeyPaytm: "",
    secretkeyPaytm: "",
    appkeyCashFree: "",
    secretkeyCashFree: "",
    startDate: "",
    endDate: "",
    UPIID: "",
    paymentTypeOnline: false,
    paymentTypeCod: false,
    accountName: "",
    bankName: "",
    ifscCode: "",
    accountNumber: "",
    accEmail: "",
    accPhone: "",
    fetchCatagoryKey: false,
    vendorModeOptionSelect: "",
    venderId: "",
    modeOfSale: "",
  };
  public async callCatalogTree() {
    this.isLoading = true;
    const currentUserData = (this as any).$currentUserData;
    if (sessionStorage.getItem("userRole") == "Admin") {
      let data = await this.$store.dispatch(
        "tenant/getTenantDetailByID",
        currentUserData.tenant
      );
      const catalogId = data.response.agreement.businessSegmentInfo.map(
        (x) => x.catalogId
      );
      let searchString = `parent=${catalogId}`;
      await this.$store.dispatch("catalog/fetchCatalogList", searchString);
      let domainRes = this.$store.getters["catalog/GetCategoryList"];
      this.marketListStore = domainRes.data.response;
    }
    let dataDomain = await this.catalogDomainData;
    if (
      Array.isArray(dataDomain) &&
      dataDomain.length > 0 &&
      dataDomain[0].categoryType == "DOMAIN"
    ) {
      let searchString = `parent=${dataDomain[0].catalogId}`;
      await this.$store.dispatch("catalog/fetchCatalogList", searchString);
      let domainRes = this.$store.getters["catalog/GetCategoryList"];
      this.marketListStore = domainRes.data.response;
    }
    if (
      Array.isArray(dataDomain) &&
      dataDomain.length > 0 &&
      dataDomain[0].categoryType == "MARKET"
    ) {
      dataDomain.forEach(async (obj) => {
        await this.$store
          .dispatch("catalog/fetchCatalogById", obj.catalogId)
          .then((res) => {
            this.marketListStore.push(res.response);
          });
      });
    }

    this.isLoading = false;
  }
  public readAgreement(e) {
    this.uploadFile(e.target.files[0]);
  }
  public async uploadFile(file) {
    let formdata = new FormData();
    formdata.append("file", file);
    formdata.append(
      "key",
      (
        Date.now().toString(36) + Math.random().toString(36).substr(2, 5)
      ).toLowerCase()
    );
    formdata.append("isPublic", JSON.stringify(true));
    formdata.append("replaceExisting", JSON.stringify(true));
    formdata.append("basePath", "partner");
    this.showCustomToast();
    await this.$store
      .dispatch("inventory/uploadFileToStorage", formdata)
      .then((res) => {
        this.agreement.file = res.data.fileUrl;
      })
      .catch((error) => {
        this.$swal({
          type: "error",
          text: "File Upload failed! please try again.",
        });
        this.clearCustomToast();
      });
  }
  public showCustomToast() {
    Vue.toasted.show("Uploading...", {
      type: "info",
      theme: "toasted-primary",
      singleton: true,
      duration: 1000,
    });
  }
  public isValid() {
    const isValid = this.$refs.observer.validate();
    this.$emit("isValid", isValid);
    return isValid;
  }
  public clearCustomToast() {
    Vue.toasted.clear();
  }
  public async mounted() {
    let storageDataUser: any = sessionStorage.getItem("userLogin");
    let dataDomain = JSON.parse(storageDataUser).catalogInfo;

    if (
      Array.isArray(dataDomain) &&
      dataDomain.length > 0 &&
      dataDomain[0].categoryType == "CATEGORY"
    ) {
      this.isMarketShow = false;
      this.agreement.fetchCatagoryKey = true;
      dataDomain.forEach(async (obj) => {
        await this.$store
          .dispatch("catalog/fetchCatalogById", obj.catalogId)
          .then((res) => {
            this.catalogsOptionsCategory.push(res.response);
          });
      });
    } else {
      this.isMarketShow = true;
    }
  }
}
